// extracted by mini-css-extract-plugin
export var activeFilterButton = "_r4-c";
export var backButton = "_r4-4";
export var backIcon = "_r4-5";
export var chevronShortcut = "_r4-6";
export var container = "_r4-1";
export var editor = "_r4-8";
export var editorWrapper = "_r4-7";
export var prefix = "_r4-2";
export var searchIcon = "_r4-3";
export var suffix = "_r4-9";
export var suffixContent = "_r4-a";
export var suffixText = "_r4-b";
export var wrapper = "_r4-0";